<template>
  <div>
    <v-card
      color="red"
      flat
      tile
    >
      <v-toolbar dense
                 src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
      >
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="users"
      class="elevation-1"
      :search="search"
      :items-per-page="-1"
      :expanded="expanded"
      locale="cs"
      item-key="id"
      show-expand
      :single-expand="true"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Uživatelé</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer>Výpis</v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Vyhledávání"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="getUsers">Reset</v-btn>
      </template>

      <template v-slot:expanded-item="{ headers, item }" >
        <td :colspan="headers.length">
          <v-container fluid>
            <v-row cols="12">
              <v-col cols="6">
                <table :colspan="headers.length">
                  <tr>
                    <td>Telefon 2</td>
                    <td>{{item.phone2}}</td>
                  </tr>
                  <tr>
                    <td>Telefon 3</td>
                    <td>{{item.phone3}}</td>
                  </tr>
                  <tr>
                    <td>Interní poznámka</td>
                    <td>{{item.description}}</td>
                  </tr>
                  <tr>
                    <th>Dodací údaje</th>
                    <th></th>
                  </tr>
                  <tr>
                    <td>Ulice</td>
                    <td>{{item.deliveryStreet || item.street}}</td>
                  </tr>
                  <tr>
                    <td>Č.p.</td>
                    <td>{{item.deliveryStreetNumber || item.streetNumber}}</td>
                  </tr>
                  <tr>
                    <td>Město</td>
                    <td>{{item.deliveryCity || item.city}}</td>
                  </tr>
                  <tr>
                    <td>PSČ</td>
                    <td>{{item.deliveryZip || item.zip}}</td>
                  </tr>
                </table>
              </v-col>
              <v-col cols="6">
                <table>
                  <tr>
                    <th>Firma</th>
                    <th></th>
                  </tr>
                  <tr>
                    <td>Název</td>
                    <td>{{item.companyName}}</td>
                  </tr>
                  <tr>
                    <td>IČO</td>
                    <td>{{item.ico}}</td>
                  </tr>
                  <tr>
                    <td>DIČ</td>
                    <td>{{item.dic}}</td>
                  </tr>
                </table>
              </v-col>
            </v-row>
            <v-data-table
              :items="item.boarders"
              :headers="boarderHeaders"
              dense
              :search="search"
              style="background-color: #eaeaea"
            >
            </v-data-table>
          </v-container>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'Users',
  data () {
    return {
      loading: true,
      search: '',
      expanded: [],
      boarderHeaders: [{
        text: 'Jméno',
        value: 'firstName'
      },
      {
        text: 'Příjmení',
        value: 'lastName'
      },
      {
        text: 'Jídelníček',
        value: 'diets[0].name'
      }],
      headers: [
        {
          text: 'Jméno',
          align: 'start',
          sortable: true,
          value: 'firstName'
        },
        { text: 'Příjmení', value: 'lastName' },
        { text: 'Id', value: 'id' },
        { text: 'Ověřeno', value: 'verified' },
        { text: 'Telefon', value: 'phone1' },
        { text: 'Ulice', value: 'street' },
        { text: 'č.p.', value: 'streetNumber' },
        { text: 'PSČ', value: 'zip' },
        { text: 'Město', value: 'city' },
        { text: 'Dluh', value: 'debt' },
        { text: 'Kredit', value: 'credit' },
        { text: 'Bankovní převod', value: 'bankTransfer' }
      ],
      users: [],
      expandedBoarders: []
    }
  },
  created () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.getUsers()
    },
    getUsers () {
      this.loading = true
      this.$http.get('/admin/users/archive')
        .then(response => {
          this.users = this.keysToCamelCase(response.data).map(user => {
            user.bankTransfer = user.paymentTransfer ? 'Ano' : 'Ne'
            user.debt = !user.maxDebt ? 'Nepovolen' : (user.credit > 0 ? 0 : user.credit * (-1))
            user.credit = user.credit > 0 ? user.credit : 0
            user.verified = user.emailVerifiedAt ? 'Ano' : 'Ne'

            return user
          })
          this.loading = false
        })
        .catch(err => console.log(err))
    }
  }
}
</script>

<style scoped>
.container{
}
</style>
